<template>
  <div>
    <vs-popup
      title="Pegar Atendimento"
      :active.sync="pickingPopupIsActive"
      class="contact-picking-popup"
      @close="closePopup"
      id="sizePopup"
    >
      <div class="contact__avatar mr-1">
        <vs-row class="mt-2" vs-type="flex" vs-justify="center">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-avatar
                v-if="chatTicket && chatTicket.customer && chatTicket.customer.image"
                class="border-2 border-solid border-white"
                :src="chatTicket.customer.image"
                size="60px"
            />
            <vs-avatar v-else class="border-2 border-solid border-white" size="60px" />
            <span v-if="chatTicket && chatTicket.customer && chatTicket.customer.name" style="padding-left: 10px">{{ chatTicket.customer.name }}</span>
          </vs-col>
        </vs-row>
        <vs-row class="mt-10" vs-type="flex" vs-justify="center">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-button
              class="attendance-span"
              type="border"
              @click.prevent="closePopup"
            >
              <span>
                CANCELAR
              </span>
            </vs-button>
            <vs-button
              class="attendance-span ml-10"
              @click.prevent="pickTicket"
            >
              <span>
                CONFIRMAR
              </span>
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>

import InboxTimer from './InboxTimer.vue'

import { ChatTicketService } from "@/db/chatTicket_service";
import { transferChatTicket } from '@/http/requests/chatTicket';

export default {
  components: {
    InboxTimer
  },
  data() {
    return {
      transferring: false
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
    setting() {
      return this.$store.state.settings.settings.limit_chat_tickets;
    },
    chatActives() {
      return this.$store.state.chat.chatActives
    },
    limitChatTicketsActivated() {
      return this.$store.state.settings.settings.limit_chat_tickets_activated;
    },
    chatTicket() {
      return this.$store.state.chatContact.chatPickingPopup
    },
    pickingPopupIsActive() {
      return this.$store.state.chatContact.pickingPopupIsActive
    },
  },
  methods: {
    closePopup() {
      this.$store.dispatch('chatContact/changeStatusPickingPopupActive', false);
    },
    async pickTicket() {
      if (this.activeUserInfo.role) {
        const ctService = new ChatTicketService()
        if (
            this.activeUserInfo.role.name === "administrador" ||
            (Number(this.limitChatTicketsActivated) && (this.setting > await ctService.getCountChatActive())) ||
            !Number(this.limitChatTicketsActivated)
        ) {
          transferChatTicket(this.chatTicket.id, this.activeUserInfo.id).then(async (response) => {
            const { user_id, pickable_at } = response.data.data['transferChatTicket'];

            if ( user_id && pickable_at && user_id !== this.activeUserInfo.id ) {
              this.closePopup()

              this.$vs.notify({
                time: 7000,
                color: "danger",
                title: "Transferência não efetuada!",
                text: "Atendimento coletado por outro usuário."
              })

              return setTimeout(() => {
                this.$events.emit('CheckSocket', { 'timestamps': pickable_at })
              }, 300)
            }

            this.transferring = true;
            this.$events.emit('ChatTicketTransferringLabelUpdate', {
              chatTicket: this.chatTicket,
              isTransferring: true
            })

            this.closePopup()
          })
          .catch((error) => {
            console.error(error);
            setTimeout(() => {
              this.$events.emit('CheckSocket', { 'refresh': true })
            }, 300)
          });
        } else {
          return this.$vs.notify({
            color: "danger",
            title: "Limite de atendimentos atingido!",
            text: "Você não pode pegar este atendimento porque o limite de atendimentos simultâneos foi atingido."
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
.inbox-dropdown {
  position: relative;
  margin: 0 10px;
  width: 40%;
  height: 65px;

  &__picking-button[style] {
    background: #fff !important;
    position: absolute;
    left: 0;
    bottom: 0;
    padding-top: .500rem !important;
    padding-bottom: .500rem !important;
    width: 100%;
  }
}
</style>